import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Ordinances from '../Ordinances/OrdinancesELe'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Ordinances & Regulations"/>
        <Ordinances />
      </>
    )
  }
  
  export default Main